'use strict';
import React from 'react';
import flux from 'utils/flux';
import store from 'store';
import {Navigation} from 'react-router';
import {removeFromPipedQuery} from 'utils/strings';
import fallbackConfig from '../../fallbackConfig';
import {decodeUrl, encodeUrl, encodeBackendUrl} from '../../utils/strings';

var AltFilterCategory = React.createClass({

    displayName: 'altFilterCategory',

    mixins: [Navigation],

    propTypes: {
        filter: React.PropTypes.object,
        query: React.PropTypes.object,
        ix: React.PropTypes.number
    },

    contextTypes: {
        router: React.PropTypes.func.isRequired
    },

    getInitialState() {
        let listOfFilters = this.createListOfFilters();
        let query = this.createQuery(listOfFilters);
        let toggledFilters = {};

        this.props.filter.get('children').toJS().forEach(category => {
            category.children.forEach(child => {
                if (child.active) {
                    toggledFilters[category.value] = true;
                }
                child.children.forEach(child2 => {
                    if (child2.active) {
                        toggledFilters[child.value] = true;
                    }
                });
            });
        });

        return {
            searchValue: '',
            listOfFilters: listOfFilters,
            clear: Object.keys(listOfFilters).length === 0 && listOfFilters.constructor === Object,
            clearing: false,
            query: query,
            toggled: toggledFilters,
            showFilterButton: false
        };
    },
    createQuery(listOfFilters) {
        let query = "";
        for (const category in listOfFilters) {
            query = query + category + '=';
            for (const tag of listOfFilters[category]) {
                query = query + encodeUrl(tag) + '|';
            }
            query = query.slice(0, -1) + "&";
        }
        query = query.slice(0, -1);

        return query;
    },
    createListOfFilters() {
        const activeFilters = this.props.selectedFilters.toJS();
        let listOfFilters = {};
        for (const filter of activeFilters) {
            const paramKey = Object.keys(filter.params)[0];
            const paramValue = filter.params[paramKey];
            let array = [paramValue];

            if (listOfFilters.hasOwnProperty(paramKey)) {
                array = listOfFilters[paramKey];
                array.push(paramValue);
                listOfFilters[paramKey] = array;
            } else {
                listOfFilters[paramKey] = array;
            }
        }

        return listOfFilters;
    },
    createSelectedCategoryFilter(lof) {
        let result = {};
        let allChildren = this.props.filter.toJS().children;
        for (let child of allChildren) {
            let paramName = child.params.split("=")[0];
            if (lof.hasOwnProperty(paramName) && lof[paramName]) {
                result[paramName] = lof[paramName];
            }
        }

        return result;
    },
    componentDidUpdate(prevProps) {
        if (prevProps.selectedFilters !== this.props.selectedFilters) {
            let listOfFilters = this.createListOfFilters();
            this.setState({
                listOfFilters: listOfFilters,
                query: this.createQuery(listOfFilters),
                showFilterButton: false
            });
        }

        const clearFlag = Object.keys(this.props.query).length > 0 && this.props.query.constructor === Object && this.props.query.hasOwnProperty('clearFlag') ? true : false;
        if (clearFlag && !this.state.clearing) {
            this.setState({
                listOfFilters: {},
                clearing: true,
                clear: true,
                searchValue: ''
            });
            this.context.router.transitionTo('landing-page', null, null);
        }
        else if (!clearFlag && this.state.clearing) {
            this.setState({
                clearing: false,
            });
        }
    },

    filterSearchChange(e) {
        let toggled = {};

        if (e.target.value && this.props.filter.get('active')) {
            this.props.filter.get('children').toJS().forEach((category) => {
                category.children && category.children.forEach((subCategory) => {
                    if (subCategory && this.isCategoryMatchingSearch(subCategory.name.toLowerCase(), e.target.value.toLowerCase())) {
                        toggled[category.value] = true;
                    }
                    subCategory.children && subCategory.children.forEach((subSubCategory) => {
                        if (subSubCategory && this.isCategoryMatchingSearch(subSubCategory.name.toLowerCase(), e.target.value.toLowerCase())) {
                            toggled[category.value] = true;
                            toggled[subCategory.value] = true;
                        }
                    });
                });
            });
        }

        this.setState({
            searchValue: e.target.value,
            toggled: toggled
        });
    },

    toggleCategory(event, child, forceOpen = false) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.state.toggled[child.value] = forceOpen || !!!this.state.toggled[child.value];
        this.setState({toggled: this.state.toggled});
    },

    getPerPageParam() {
        // get it from store, if it is used in this session
        if (store.get('pagination_amount')) {
            return store.get('pagination_amount');
        }
        // get it from config
        const {defaultPerPageResults} = flux.getStore('app').getState().config.toJS();

        if (Number.isInteger(defaultPerPageResults)) {
            return defaultPerPageResults;
        }
        return fallbackConfig.defaultPerPageResults;
    },
    clearCategoryFilters() {
        const categoryChildren = this.props.filter.get('children').toJS();
        if (categoryChildren && categoryChildren.length > 0) {
            let queryObj = flux.getStore('media').state.query.toObject();
            categoryChildren.map(child => {
                const params = child.params.split('&');
                params.map(param => {
                    const categoryName = param.substring(0, param.indexOf('='));
                    queryObj[categoryName] = null;
                });
            });
            this.setState({listOfFilters: {}, clear: true, showFilterButton: false});
            flux.getActions('media').updateFilterParams(queryObj);
            this.getResults();
        }
    },
    getResults(e = null) {
        e && e.preventDefault();

        let query = "";
        const queryObj = flux.getStore('media').state.query.toObject();
        if (!queryObj.hasOwnProperty('per_page')) {
            queryObj['per_page'] = this.getPerPageParam();
        }

        if (Object.keys(queryObj).length === 1) {
            delete queryObj['per_page'];
        }

        Object.keys(queryObj).forEach(key => {
            let queryObjElement = queryObj[key];
            query = `${query}${key}=${encodeUrl('' + queryObjElement)}&`
        });

        query = query.slice(0, -1);

        this.setState({
            clear: Object.keys(this.state.listOfFilters).length === 0 && this.state.listOfFilters.constructor === Object
        });
        window.location.href = `/#/media${query != "" ? "?" : ""}${query}`;
    },

    renderFilterMenu() {
        if (this.props.filter.get('active')) {
            let searchedFilters = this.props.filter.get('children').toJS().filter((category) => {
                let searchedChildren = [];
                if (category.children.length) {
                    searchedChildren = category.children.filter((subCategory) => {
                        let searchedChildren = [];
                        if (subCategory.children.length) {
                            searchedChildren = subCategory.children.filter((subSubCategory) => {
                                return this.state.searchValue ? this.isCategoryMatchingSearch(subSubCategory.name.toLowerCase(), this.state.searchValue.toLowerCase()) : true;
                            });
                        }

                        subCategory["children"] = searchedChildren;
                        return this.state.searchValue ? (this.isCategoryMatchingSearch(subCategory.name.toLowerCase(), this.state.searchValue.toLowerCase()) || searchedChildren.length) : true;
                    });
                }

                category["children"] = searchedChildren;
                return this.state.searchValue ? (this.isCategoryMatchingSearch(category.name.toLowerCase(), this.state.searchValue.toLowerCase()) || searchedChildren.length) : true;
            });

            return (this.renderFilterList(searchedFilters, true));
        }
    },

    isCategoryMatchingSearch(name, searchValue) {
        let includes = true;
        searchValue.split(' ').forEach(string => {
            if (name !== "" && !name.includes(string)) {
                includes = false;
            }
        });
        return includes;
    },

    renderFilterList(children, firstLevel = false) {
        let cssOptions = {}
        let height = 66;
        let filterHeight = this.props.filerHeight;
        let arraySize = children.length;

        for (const child of children) {
            arraySize = arraySize + child.children.length;
            if (!!filterHeight) {
                height = height + 34;
                filterHeight = filterHeight - 1;

                if (child.children.length) {
                    for (const grandchild of child.children) {
                        if (!filterHeight) break;
                        height = height + 28;
                        filterHeight = filterHeight - 1;
                    }
                }
            }
        }
        (filterHeight === 0) && firstLevel ? cssOptions = {maxHeight: height + 'px', overflowY: "scroll"} : null;
        return (
            <div>
                {firstLevel ?
                    <div className="search-field">
                        {(arraySize > this.props.filerHeight || this.state.searchValue.length) ?
                            <input type="text" onChange={this.filterSearchChange} value={this.state.searchValue}
                                   placeholder={flux.t('filter_search')}/> : ''}
                    </div> : ''
                }

                <ul className={`category__list ${firstLevel ? 'first-level' : ''}`} style={cssOptions}>
                    {children.map((child) => {
                        return this.checkFilterElement(child);
                    })}
                </ul>


                {(firstLevel && (this.state.showFilterButton || !this.state.clear) && this.state.showFilterButton) ?
                    <button className="category query-button btn btn-border apply" value={this.state.query} onClick={this.getResults}>{flux.t('filter_button')}
                    </button> : ''}

                {(firstLevel && this.showClearFilter() && !!this.props.filter.get('show_filter_button')) ?
                    <button className="category query-button btn btn-border clear-filter" value={this.state.query}
                            onClick={this.clearCategoryFilters}>{flux.t('clear_category_button')}
                    </button> : ''}

            </div>
        );
    },
    showClearFilter() {
        let selectedFiltersCategory = this.createListOfFilters(this.props.selectedFilters.toJS());
        let ownPropertyNames = Object.getOwnPropertyNames(selectedFiltersCategory);
        if (ownPropertyNames && ownPropertyNames.length > 0) {
            let allChildren = this.props.filter.toJS().children;
            for (let child of allChildren) {
                let paramName = child.params.split("=")[0];
                if (selectedFiltersCategory.hasOwnProperty(paramName) && selectedFiltersCategory[paramName].length > 0) {
                    return true
                }
            }

        }

        return false;
    },
    hasCategoryFilters() {
        return Object.getOwnPropertyNames(this.state.listOfFilters).length != 0;
    },
    checkFilterElement(child) {
        if (child.hidden) {
            return null;
        }

        return (this.renderFilterElement(child));
    },

    toggleFilters(child) {
        const params = child.params.split('&');
        let listOfFilters = this.state.listOfFilters;
        const removedFilters = [];

        for (const param of params) {
            const paramKey = param.split('=')[0];
            const paramValue = decodeUrl(param.split('=')[1]);
            let array = [paramValue];

            if (listOfFilters.hasOwnProperty(paramKey)) {
                array = listOfFilters[paramKey] ? listOfFilters[paramKey].map(v => v) : [];
                const index = array.indexOf(paramValue);
                if (index > -1) {
                    array.splice(index, 1);
                    if (!array.length) {
                        delete listOfFilters[paramKey];
                        removedFilters.push(paramKey);
                    } else
                        listOfFilters[paramKey] = array;
                } else {
                    array.push(paramValue);
                    listOfFilters[paramKey] = array;
                }
            } else {
                listOfFilters[paramKey] = array;
            }
        }

        let filterParams = {};
        for (const category in listOfFilters) {
            let orFilter = '';
            for (const value of listOfFilters[category]) {
                orFilter = orFilter + value + '|';
            }
            orFilter = orFilter.slice(0, -1);
            filterParams[category] = orFilter;
        }

        removedFilters.forEach(category => {filterParams[category] = null})
        flux.getActions('media').updateFilterParams(filterParams);

        // window.location.href = `/#/media${query != "" ? '?' : ''}${query}`;

        this.setState({
            listOfFilters: listOfFilters,
            showFilterButton: !!this.props.filter.get('show_filter_button') ? this.showFilterButton(listOfFilters) : false
        });

        if (!!!this.props.filter.get('show_filter_button')) {
            this.getResults();
        }
    },
    showFilterButton(listOfFilters) {
        let selectedFiltersCategory = this.createListOfFilters(this.props.selectedFilters.toJS());
        for (const category in listOfFilters) {
            let selectedCategoryFilter = selectedFiltersCategory[category];
            let listOfFilter = listOfFilters[category];
            if (!selectedFiltersCategory
                || !selectedFiltersCategory.hasOwnProperty(category)
                || selectedCategoryFilter.length !== listOfFilter.length) {
                return true;
            }

            for (let selectedValue of selectedCategoryFilter) {
                if (listOfFilter.indexOf(encodeUrl(selectedValue)) === -1) {
                    return true;
                }
            }
        }
        return false;
    },
    renderFilterElement(child) {
        let isActive = child.selected;
        // Fallback check for "apply filter" being weird
        if (!isActive) {
            const listOfFilters = this.state.listOfFilters;
            const params = child.params.split('&');
            for (const param of params) {
                const paramKey = param.split('=')[0];
                const array = listOfFilters[paramKey] || [];
                if (array.indexOf(child.value) !== -1) {
                    isActive = true;
                    break;
                }
            }
        }

        return (
            <li key={child.value}>
                <div className={isActive ? 'active tag-link' : 'tag-link'}
                     id={child.value}
                     onClick={() => this.toggleFilters(child)}
                     dataParams={child.params}>
                    {child.children.length ? <span className="toggle-button" href="#" onClick={(event) => this.toggleCategory(event, child)}><i className={!!this.state.toggled[child.value] ? 'chevron-down' : 'chevron-right'} /></span>
                        : <span className="toggle-button">&nbsp;</span>}
                    <div className="child-label">
                        {child.name} ({child.count})
                        {isActive ? <span className="list__clear close"/> : ''}
                    </div>
                </div>
                {(() => {
                    if (child.children.length && (!!this.state.toggled[child.value])) {
                        return this.renderFilterList(child.children);
                    }
                })()}
            </li>
        );
    },
    toggleFilter(e) {
        e.preventDefault();
        flux.getActions('media').toggleFilter(this.props.ix);
    },

    render() {
        return (
            <div>
                <div className="filters__category">
                    <a href="#" onClick={this.toggleFilter} className="category__header">
                        {this.props.filter.get('name')}
                        <i className={this.props.filter.get('active') ? 'collapse-small' : 'expand-small'} />
                    </a>
                    {this.renderFilterMenu()}
                </div>
            </div>
        );
    }
});

module.exports = AltFilterCategory;



// WEBPACK FOOTER //
// ./app/pages/media/altFilterCategory.jsx